module.exports = __webpack_public_path__ + "static/media/s_v5_t8_1.7b391247.mp3";